import * as React from "react";

function SvgBBiconsInformaceOKlientovi(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <g data-name="Informace o uzivateli">
          <path d="M25.54 45.64a8.73 8.73 0 00-8.68 8.8v91.12a8.74 8.74 0 008.68 8.8h148.92a8.74 8.74 0 008.68-8.8V54.44a8.73 8.73 0 00-8.68-8.8zm88.13 19.19h55.4c.49 0 .88.28.88.62v6.07c0 .34-.39.62-.88.62h-55.4c-.49 0-.88-.28-.88-.62v-6.07c0-.34.39-.62.88-.62zm0 21.92h55.4c.49 0 .88.28.88.62v6.08c0 .33-.39.62-.88.62h-55.4c-.49 0-.88-.29-.88-.62v-6.08c0-.37.39-.62.88-.62zm-.22 21.92h40.65a.65.65 0 01.66.62v6.08a.65.65 0 01-.66.62h-40.65a.65.65 0 01-.66-.62v-6.08a.65.65 0 01.66-.62z" />
          <path
            d="M64.38 60.14a23.93 23.93 0 1024.31 23.92 24.11 24.11 0 00-24.31-23.92zm0 5A19 19 0 1145 84.06 19.16 19.16 0 0164.38 65.1zm19.74 37.4a2.48 2.48 0 00-1.66 4.57A34.08 34.08 0 0199 136.16a2.49 2.49 0 005 0 39 39 0 00-18.87-33.32 2.63 2.63 0 00-1.01-.34zm-40.21.09a2.35 2.35 0 00-.93.35 39 39 0 00-18.71 33.22 2.48 2.48 0 005 0 34 34 0 0116.36-29 2.48 2.48 0 00-1.68-4.56z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgBBiconsInformaceOKlientovi;
